import React from 'react';
import Image from 'next/image';

/**
 * KIS-style page header with hero image + title card.
 * Бүх дотоод хуудасны дээд хэсэгт ашиглана.
 *
 * Props:
 *   title    — (заавал биш) хуудасны гарчиг
 *   subtitle — (заавал биш) доод мөр
 *   image    — cover зураг URL. Default: /homeCover.jpg
 */
const PageHero = ({ title, subtitle, image = '/placeholders/hero-default.svg' }) => {
    return (
        <div className="relative h-[380px] md:h-[460px] overflow-hidden">
            <Image
                src={image}
                alt={title || 'Mongol Refinery'}
                fill
                className="object-cover"
                priority
            />
            <div className="absolute inset-0 bg-brand-dark/40" />
            {title && (
                <div className="relative z-10 max-w-7xl mx-auto px-6 h-full flex items-end pb-16">
                    <div className="bg-brand-dark text-white px-10 py-8 max-w-xl">
                        <h1 className="text-3xl md:text-5xl font-black tracking-tight leading-tight">
                            {title.toUpperCase()}
                        </h1>
                        {subtitle && (
                            <p className="text-white/80 mt-2 text-sm md:text-base">{subtitle}</p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PageHero;
